import * as React from 'react';

export type StaticContentModalProps = {
  openerId: string;
  size?: 'medium' | 'large';
  titleContent?: string;
  displayCloseButton: boolean;
};

const isJQueryAvailable = () => !!(window as any).$;
const initializeWebappPlugins = () => (window as any).webapp.initializePlugins();

class StaticContentModal extends React.PureComponent<StaticContentModalProps> {
  private modalRef = React.createRef<HTMLDivElement>();

  componentDidMount() {
    if (isJQueryAvailable() && this.modalRef.current) {
      const modalRefElement: JQuery<HTMLDivElement> = $(this.modalRef.current);
      // we have to call initializeWebappPlugins, as soon as the modal
      // is starting its animation to let the navtabs in the
      // gallery modal span over the full width. Especially in mobile view.
      // It has to happen on animation start, as otherwise there would
      // be a visible rerender of the navtabs
      // The Compendium Team is aware of this problem and plan on removing JS from the navtabs
      modalRefElement.on('animationstart webkitAnimationStart oanimationstart MSAnimationStart', initializeWebappPlugins);
      // As the previous initializeWebappPlugins has to be called so early,
      // the height of the backdrop is calculated wrong.
      // So we have to call initializeWebappPlugins one more time,
      // set the right height of the backdrop
      modalRefElement.on('shown.bs.modal', () => setTimeout(() => initializeWebappPlugins(), 200));
    }
  }

  componentWillUnmount() {
    if (isJQueryAvailable() && this.modalRef.current) {
      const modalRefElement: JQuery = $(this.modalRef.current);
      modalRefElement.off();
    }
  }

  private getShortSize = () => {
    const { size = 'large' } = this.props;
    switch (size) {
      case 'medium':
      default:
        return 'md';
      case 'large':
        return 'lg';
    }
  };

  render() {
    const {
      openerId, titleContent, displayCloseButton, children,
    } = this.props;
    const shortSize = this.getShortSize();

    return (
      <div className="modal fade" id={openerId} tabIndex={-1} role="dialog" ref={this.modalRef}>
        <div className={`modal-dialog modal-${shortSize} modal-has-header modal-has-footer`} role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button className="close" type="button" data-dismiss="modal" aria-label="Close">
                <span>×</span>
              </button>
              {titleContent && (
              <h4 className="modal-title" dangerouslySetInnerHTML={{ __html: titleContent }} />
              )}
            </div>
            <div className="modal-body">{children}</div>
            {displayCloseButton && (
            <div className="modal-footer">
              <button type="button" className="btn" data-dismiss="modal">Schließen</button>
            </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default StaticContentModal;
